import { Box, Typography } from "@mui/material";
import React from "react";

import "@splidejs/react-splide/css/skyblue";

import BlurredProgressiveImage from "../components/BlurredProgressiveImage";

const PortfolioProjectMobile = (props) => {
  const imgWidth = props.lessMD ? "86vw" : "67vw";
  const paddingBetween = { xs: 0.7, sm: 1, md: 1 };
  return (
    <Box>
      <Box
        pt={{ xs: 12, sm: 13, md: 20, lg: 20, xl: 20 }}
        pb={{ xs: 3, sm: 4, md: 10, lg: 10, xl: 13 }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box width={imgWidth}>
            <Typography
              variant="h3"
              sx={{ fontSize: { xs: 26, sm: 32, md: 40, lg: 50, xl: 60 } }}
            >
              {props.title}
            </Typography>
            <Box>
              <Typography
                variant="body1"
                fontSize={{ xs: 12, sm: 13, md: 16, lg: 16, xl: 17 }}
              >
                {props.description}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              pt: { xs: 3, sm: 3, md: 7, lg: 7, xl: 7 },
              px: paddingBetween,
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            {props.column.map((el) => (
              <Box
                py={paddingBetween}
                sx={{ display: "flex" }}
                width={imgWidth}
                key={el}
              >
                <BlurredProgressiveImage
                  src={`/assets/portfolio/${props.folder}/${el}_small.jpg`}
                  placeholder={`/assets/portfolio/${props.folder}/${el}_tiny.jpg`}
                  alt={`project${el}`}
                  width="100%"
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PortfolioProjectMobile;
